import { styled } from '@mui/material'
import MuiTab from '@mui/material/Tab'

export type { TabProps } from '@mui/material/Tab'

const Tab = styled(MuiTab)(() => ({
  textTransform: 'none',
  minWidth: '11em',
}))

export default Tab
